import {Select} from '@hconnect/common/components'
import {ControlledFormField, FormFieldBase, SelectOption} from '@hconnect/common/types'
import {StatusLabel} from '@widgets/common-shift-event'
import {Controller, FieldValues} from 'react-hook-form'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {TaskStatus} from '../../types'

type Props<TField extends FieldValues> = FormFieldBase &
  ControlledFormField<TField> & {
    allowedStatuses: readonly TaskStatus[]
    onChange?: (value: TaskStatus | undefined, previousValue: TaskStatus | undefined) => void
  }

export const TaskStatusField = <TField extends FieldValues>(props: Props<TField>) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const options: SelectOption<TaskStatus>[] = props.allowedStatuses.map((status) => ({
    value: status,
    label: t(`task.status.${status}`)
  }))

  return (
    <Controller
      name={props.name}
      control={props.control}
      disabled={props.disabled || props.readOnly}
      render={({field, fieldState}) => (
        <Select
          data-test-id={`select-field-${field.name}`}
          name={field.name}
          options={options}
          label={props.label}
          value={field.value}
          onChange={(value) => {
            const previousValue = field.value
            field.onChange(value)
            props.onChange?.(value, previousValue)
          }}
          getOptionLabel={({value, label}) => <StatusLabel status={value} label={label} />}
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
          disabled={props.disabled}
          required={props.required}
          optional={props.optional}
          readOnly={props.readOnly}
        />
      )}
    />
  )
}
